import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicAvailability } from '../../enums';
import { SalesType } from '../../../shared/enums';

@jsonObject
export class PublicSalesResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly type!: SalesType;

  @jsonMember(String)
  public readonly availability!: PublicAvailability;

  @jsonMember(String)
  public readonly subProductId?: Nillable<Guid>;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder?: Nillable<number>;
}
